import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Overlay } from 'src/components/Overlay';
import SingleItem from 'src/layouts/SingleItem';
import { AdjudicationSidebar } from './AdjudicationSidebar';
import { useAdjudicationData } from 'src/contexts/AdjudicationDataProvider';
import { SubmissionDetails } from './SubmissionDetailsTab';
import ReviewTab from './ReviewTab';
import { ProxyBanner } from 'src/components/ProxyUser/ProxyUser';

export const ADJUDICATION_DETAILS_TAB = {
  SUBMISSION: 'Submission',
  REVIEW: 'Reviews'
} as const;

export type AdjudicationsDetailsTab =
  (typeof ADJUDICATION_DETAILS_TAB)[keyof typeof ADJUDICATION_DETAILS_TAB];

const renderTab = (tab: AdjudicationsDetailsTab) => {
  switch (tab) {
    case ADJUDICATION_DETAILS_TAB.SUBMISSION:
      return <SubmissionDetails />;
    case ADJUDICATION_DETAILS_TAB.REVIEW:
      return <ReviewTab />;
    default:
      return null;
  }
};

const Adjudication = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [activeTab, setActiveTab] = useState<AdjudicationsDetailsTab>(
    ADJUDICATION_DETAILS_TAB.SUBMISSION
  );
  const { isInviteRequestAccepted: isAdjudicationRequestAccepted } =
    useAdjudicationData();

  const closeItem = () => {
    if (location.key !== 'default') {
      return navigate(`/app/adjudications?${searchParams.toString()}`);
    }
    return navigate(`${location.pathname}?${searchParams.toString()}`);
  };

  const invitedAssessmentTab = Object.values(ADJUDICATION_DETAILS_TAB).filter(
    tab => tab === ADJUDICATION_DETAILS_TAB.SUBMISSION
  );

  return (
    <Overlay>
      <ProxyBanner />

      <SingleItem width="100%">
        <SingleItem.MainArea>
          <SingleItem.Navigation>
            {Object.values(
              !isAdjudicationRequestAccepted()
                ? invitedAssessmentTab
                : ADJUDICATION_DETAILS_TAB
            ).map(tab => (
              <SingleItem.Tab
                key={tab}
                onClick={() => setActiveTab(tab)}
                isActive={activeTab === tab}
              >
                {tab}
              </SingleItem.Tab>
            ))}
          </SingleItem.Navigation>
          <SingleItem.Content size={'normal'}>
            {renderTab(activeTab)}
          </SingleItem.Content>
        </SingleItem.MainArea>

        <SingleItem.Sidebar>
          <AdjudicationSidebar
            setActiveTab={setActiveTab}
            onClose={closeItem}
          />
        </SingleItem.Sidebar>
      </SingleItem>
    </Overlay>
  );
};

export default Adjudication;
